import ParseError from '../errors/ParseError';
import NotImplementedError from '../errors/NotImplementedError';
import ValueError from '../errors/ValueError';
const RoomType = {
	KITCHEN:1,
    BEDROOM:2,
    BATHROOM:3,
    EN_SUITE:4,
    OTHER:5
};
RoomType.getDescription = function(roomType){
	if(roomType===RoomType.KITCHEN)
		return "Kitchen";
	if( roomType===RoomType.BEDROOM)
		return "Bedroom";
	if( roomType===RoomType.BATHROOM)
		return "Bathroom";
	if( roomType===RoomType.EN_SUITE)
		return "En Suite";
	if( roomType===RoomType.OTHER)
		return "Other";
	return "Other";
	//throw new NotImplementedError(`Not implemented for "${roomType}"`);
};
RoomType.toStr = function(roomType){
	if( roomType===RoomType.KITCHEN)
		return "kitchen";
	if( roomType===RoomType.BEDROOM)
		return "bedroom";
	if( roomType===RoomType.BATHROOM)
		return "bathroom";
	if( roomType===RoomType.EN_SUITE)
		return "ensuite";
	if( roomType===RoomType.OTHER)
		return "other";
	return "Other";
	//throw new NotImplementedError(`Not implemented for "${roomType}"`);
};
RoomType.parse = function(value){
	if(value===undefined||value===null)
		throw ValueError('value was None');
	if(typeof(value)==='string')
		return RoomType.parseFromString(value);
	if(typeof(value)==='number')
		return RoomType.parseFromInt(value);
	throw new ParseError(`Could not parse value "${value}" to RoomType"`);
};
RoomType.parseFromString = function(value){
	value = value.toLowerCase();
	if (value==='kitchen')
		return RoomType.KITCHEN;
	if (value==='bedroom'){
		return RoomType.BEDROOM;
	}
	if (value==='bathroom'){
		return RoomType.BATHROOM;
	}
	if ( ['ensuite', 'en_suite', 'en suite'].indexOf(value)>=0){
		return RoomType.EN_SUITE;
	}
	if ( ['other'].indexOf(value)>=0){
		return RoomType.OTHER;
	}
	return RoomType.OTHER;
	//throw new NotImplementedError(`Not implemented for "${value}"`);
};
RoomType.parseFromInt = function(value){
	return value;
};
export default RoomType;